<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('integralShopGift.queryCondition') }}</div>
        <div class="ibox-tools" style="top:10px;"></div>
      </div>
      <div class="">
        <el-form :inline="true" :model="integralShopGiftInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input
              :placeholder="$t('integralShopGift.personNamePlaceholder')"
              v-model="integralShopGiftInfo.conditions.personName"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              :placeholder="$t('integralShopGift.telPlaceholder')"
              v-model="integralShopGiftInfo.conditions.tel"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              :placeholder="$t('integralShopGift.accountNamePlaceholder')"
              v-model="integralShopGiftInfo.conditions.personIntegralName"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="_queryIntegralShopGiftMethod"
              icon="el-icon-search"
            >
              {{ $t('integralShopGift.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('integralShopGift.title') }}</div>
        <div class="ibox-tools" style="top:10px;"></div>
      </div>
      <div class="">
        <integral-shop-gift-table
          :data="integralShopGiftInfo.integralShopGifts"
          :loading="loading"
        ></integral-shop-gift-table>
        
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="integralShopGiftInfo.total"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { listIntegralShopGift } from '@/api/shop/integralShopGiftApi'
import IntegralShopGiftTable from '@/components/shop/integralShopGift/IntegralShopGiftTable'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'IntegralShopGift',
  components: {
    IntegralShopGiftTable
  },
  data() {
    return {
      integralShopGiftInfo: {
        integralShopGifts: [],
        total: 0,
        records: 1,
        conditions: {
          personName: '',
          tel: '',
          personIntegralName: '',
          shopId: ''
        }
      },
      currentPage: 1,
      pageSize: 10,
      loading: false
    }
  },
  created() {
    this._initMethod()
  },
  methods: {
    _initMethod() {
      this._listIntegralShopGifts(this.currentPage, this.pageSize)
    },
    async _listIntegralShopGifts(page, rows) {
      this.loading = true
      this.integralShopGiftInfo.conditions.page = page
      this.integralShopGiftInfo.conditions.row = rows
      this.integralShopGiftInfo.conditions.shopId = getShopId()

      try {
        const res = await listIntegralShopGift(this.integralShopGiftInfo.conditions)
        this.integralShopGiftInfo.total = res.total
        this.integralShopGiftInfo.records = res.records
        this.integralShopGiftInfo.integralShopGifts = res.data
      } catch (error) {
        console.error('请求失败:', error)
      } finally {
        this.loading = false
      }
    },
    _queryIntegralShopGiftMethod() {
      this.currentPage = 1
      this._listIntegralShopGifts(this.currentPage, this.pageSize)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listIntegralShopGifts(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}
.ibox-title {
  border-bottom: 1px solid #e7eaec;
  padding: 15px 15px 7px;
  min-height: 48px;
}
.ibox-content {
  padding: 15px 20px 20px 20px;
}
</style>